;(() => {
	const attachBanner = el => {
		const banner = generateBanner()

		el.appendChild(banner)
	}

	const generateBanner = () => {
		const cssClass = 'banner-asiagohockey'
		const node = document.createElement('div')
		node.classList.add(cssClass)
		node.classList.add('dkreset')

		node.innerHTML = `
			<a href="${mL('url')}" target="_blank" class="${cssClass}__content">
				<div class="${cssClass}__text">
					<p class="${cssClass}__title">${mL('title')}</p>
					<p class="${cssClass}__copy">${mL('copy')}</p>
				</div>
				<button type="button" class="${cssClass}__btn">${mL('scopri')}</button>
			</a>
		`

		return node
	}

	const mL = string => {
		const lang = WC?.lang ? WC.lang.substring(0, 2) : 'it'

		const data = {
			url: {
				it: '/it/pagine/default.aspx?menu=eventi&tip=27',
				en: '/en/pagine/default.aspx?menu=events&tip=27',
				de: '/de/pagine/default.aspx?menu=veranstaltungen&tip=27',
			},
			title: {
				it: 'ASIAGO HOCKEY',
				en: 'ASIAGO HOCKEY',
				de: 'ASIAGO HOCKEY',
			},
			copy: {
				it: "Calendario eventi e partite dell'Asiago Hockey",
				en: "Calendario eventi e partite dell'Asiago Hockey",
				de: "Calendario eventi e partite dell'Asiago Hockey",
			},
			scopri: {
				it: 'Scopri',
				en: 'Discover',
				de: 'Entdecken',
			},
		}

		return data?.[string]?.[lang] || '???'
	}

	const el = document.querySelector('.body-page .riquadro')
	if (WC?.idMenu === 132 && !WC?.idCliente) {
		fetch('https://www.asiago.it/it/pagine/default.aspx?menu=eventi&tip=27')
			.then(res => res.text())
			.then(data => {
				const newdom = document.createElement('html')
				newdom.innerHTML = data
				if (newdom.querySelector('[data-article]')) {
					attachBanner(el)
				}
			})
	}
})()
